import { Button } from "@babackapp/ui/components/button";
import { Editor } from "@monaco-editor/react";
import { SaveIcon, SmileIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import type { BlockEditorFormValues } from "../types";


export function CodeEditorView() {
  const form = useFormContext<BlockEditorFormValues>();
  const values = form.watch();
  const [codeValue, setCodeValue] = useState(() =>
    JSON.stringify(values, null, 2),
  );

  // Only update when first mounted, not on every form change
  useEffect(() => {
    setCodeValue(JSON.stringify(values, null, 2));
  }, []); // Empty dependency array

  const prettifyCode = () => {
    try {
      const parsed = JSON.parse(codeValue);
      setCodeValue(JSON.stringify(parsed, null, 2));
    } catch (error) {
      console.error("Invalid JSON:", error);
    }
  };

  const saveCode = () => {
    try {
      const parsed = JSON.parse(codeValue);
      form.reset(parsed);
      // @ts-expect-error react-hook-form doesn't provide a way to change its dirty state other than this hacky trick
      form.setValue("fromCodeEditor", true, { shouldDirty: true });
    } catch (error) {
      console.error("Invalid JSON:", error);
    }
  };

  return (
    <div className="w-full h-[800px] border rounded-xl overflow-hidden relative bg-card">
      <Editor
        language="json"
        value={codeValue}
        theme="vs-dark"
        onChange={(e) => setCodeValue(e ?? "")}
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          lineNumbers: "on",
          scrollBeyondLastLine: false,
          automaticLayout: true,
        }}
      />
      <div className="flex gap-2 items-center absolute bottom-4 right-4 z-50">
        <Button size="icon" variant="secondary" onClick={prettifyCode}>
          <SmileIcon className="size-4" />
        </Button>
        <Button size="icon" variant="secondary" onClick={saveCode}>
          <SaveIcon className="size-4" />
        </Button>
      </div>
    </div>
  );
}
